/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 5d3d2bc2 (Tue Dec 30 16:20:46 UTC 2025)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Response indicating whether the user has signed the NDA.
 * @export
 * @interface FetchUserNdaStatusResponseBody
 */
export interface FetchUserNdaStatusResponseBody {
  /**
   * Whether the user has signed the NDA.
   * @type boolean
   * @memberof FetchUserNdaStatusResponseBody
   */
  hasSignedNda: boolean
  /**
   * whether or not the asset requires an NDA
   * @type boolean
   * @memberof FetchUserNdaStatusResponseBody
   */
  assetRequiresNda: boolean
}

export function FetchUserNdaStatusResponseBodyFromJSON(
  json: any
): FetchUserNdaStatusResponseBody {
  return FetchUserNdaStatusResponseBodyFromJSONTyped(json, false)
}

export function FetchUserNdaStatusResponseBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchUserNdaStatusResponseBody {
  if (json === undefined || json === null) {
    return json
  }
  return {
    hasSignedNda: json['hasSignedNda'],
    assetRequiresNda: json['assetRequiresNda'],
  }
}

export function FetchUserNdaStatusResponseBodyToJSON(
  value?: FetchUserNdaStatusResponseBody | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    hasSignedNda: value.hasSignedNda,
    assetRequiresNda: value.assetRequiresNda,
  }
}
